export interface IDateRange {
  start: { toString(): string };
  end: { toString(): string };
}

const formatDateRangeParams = (dateRange?: IDateRange): string => {
  if (!dateRange) {
    return '';
  }
  return `?start=${dateRange.start.toString()}&end=${dateRange.end.toString()}`;
};

export const PATHS = {
  HOME: '/',

  ALERTS: '/alerts',
  ACCOUNTS: '/accounts',
  DASHBOARD: '/dashboard',
  ACCOUNT: (accountId: string, dateRange?: IDateRange) => `/accounts/${accountId}${formatDateRangeParams(dateRange)}`,
  BILL: (billId: string) => `/bills/${billId}`,

  LOGIN: '/login',
  MERCHANTS: '/merchants',
  MERCHANT: (merchantId: string, dateRange?: IDateRange) =>
    `/merchants/${merchantId}${formatDateRangeParams(dateRange)}`,
  ONBOARDING: '/onboarding',
  OBLIGATIONS: '/obligations',
  SETTINGS: '/settings',
  SPENDING: (dateRange?: IDateRange) => `/spending${formatDateRangeParams(dateRange)}`,
  RECURRING_TRANSACTIONS: '/recurring-transactions',
  RECURRING_TRANSACTION: (recurringTransactionId: string) => `/recurring-transactions/${recurringTransactionId}`,
  TRANSACTION: (transactionId: string) => `/transactions/${transactionId}`,
  ASSISTANT: '/assistant',
  TRANSACTION_ROLLUPS: '/admin/transactions-chart-demo',
  DEBUG_SENTRY_TEST: '/debug/sentry-test',
  DEBUG_ENVIRONMENT: '/debug/environment',
} as const;

export type PathKey = keyof typeof PATHS;
export type PathValue = (typeof PATHS)[PathKey];
